import axios from "@/axios/development";

export async function getOutputTemplateProductCategory(productId) {
    if (typeof productId !== "string") throw new TypeError("productId must be a string, instead of:", productId);
    return (await axios(`/output-template/product/${productId}`)).data;
}
